
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseDropdown from "@/components/base/BaseDropdown.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import { refererOptions } from "@/config/refererOptions";
import { NewsletterState } from "@/models/www/store/NewsletterState";
import { useNewsletterStore } from "@/store/newsletter";
import { defineComponent, reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { watch } from "vue";

export default defineComponent({
	components: {
		BaseSection,
		BaseDropdown,
		BaseCheckbox,
	},
	setup() {
		const store = useNewsletterStore();

		const initialState = store.getState;

		const state = reactive({
			referer: initialState.referer,
			subscribe: initialState.subscribe,
		} as NewsletterState);

		const rules = {
			referer: {},
			subscribe: {},
		};

		const v$ = useVuelidate(rules, state);

		watch(state, () => {
			store.setState(state);
		});

		return { v$, refererOptions };
	},
});
